import { Controller } from "stimulus"

export default class extends Controller {


  connect() {
    console.log('toast')
    return new bootstrap.Toast(this.element, {animation: true, autohide: true, delay: 5000}).show()
  }
}